import { useAuth } from "./hooks/useAuth";
import { useMissive } from "./hooks/useMissive";
import { useCustomerLookup } from "./hooks/useCustomerLookup";
import { LoginView } from "./components/LoginView";
import { LoadingView } from "./components/LoadingView";
import { CustomerView } from "./components/CustomerView";
import { EmptyView } from "./components/EmptyView";
import { NotFoundView } from "./components/NotFoundView";
import { ErrorView } from "./components/ErrorView";

export function AppContent() {
  const { user, loading: authLoading } = useAuth();
  const conversationIds = useMissive();
  const {
    view,
    customer,
    email,
    errorMessage,
    emptyMessage,
    retry,
    searchByEmail,
    showSearch,
  } = useCustomerLookup(conversationIds);

  if (authLoading) {
    return <LoadingView />;
  }

  if (!user) {
    return <LoginView />;
  }

  switch (view) {
    case "loading":
      return <LoadingView />;
    case "customer":
      return customer ? (
        <CustomerView
          customer={customer}
          conversationId={conversationIds[0] ?? ""}
          onSearch={() => showSearch()}
        />
      ) : (
        <LoadingView />
      );
    case "notFound":
      return <NotFoundView email={email} conversationId={conversationIds[0] ?? ""} onSearch={searchByEmail} />;
    case "error":
      return <ErrorView message={errorMessage} conversationId={conversationIds[0] ?? ""} onRetry={retry} />;
    case "empty":
      return <EmptyView message={emptyMessage} conversationId={conversationIds[0] ?? ""} />;
    case "login":
      return <LoginView />;
    default:
      return <EmptyView message={emptyMessage} conversationId={conversationIds[0] ?? ""} />;
  }
}
